import React from 'react';

export const SkeletonCard = () => {
  return (
    <div className="animate-pulse">
      <div className="bg-card border border-border rounded-lg p-6">
        <div className="flex items-center justify-between mb-4">
          <div className="h-4 w-24 bg-muted rounded"></div>
          <div className="h-4 w-4 bg-muted rounded"></div>
        </div>
        <div className="h-8 w-16 bg-muted rounded"></div>
      </div>
    </div>
  );
};

export const SkeletonVehicleList = () => {
  return (
    <div className="space-y-4 animate-pulse">
      {[1, 2, 3, 4, 5].map((i) => (
        <div key={i} className="flex items-center justify-between p-4 rounded-lg bg-card border border-border">
          <div className="flex items-center gap-4">
            <div className="h-12 w-12 rounded-full bg-muted"></div>
            <div className="space-y-2">
              <div className="h-4 w-24 bg-muted rounded"></div>
              <div className="h-3 w-32 bg-muted rounded"></div>
            </div>
          </div>
          <div className="flex items-center gap-4">
            <div className="space-y-2">
              <div className="h-3 w-20 bg-muted rounded"></div>
              <div className="h-4 w-16 bg-muted rounded"></div>
            </div>
            <div className="space-y-2">
              <div className="h-3 w-16 bg-muted rounded"></div>
              <div className="h-4 w-12 bg-muted rounded"></div>
            </div>
            <div className="h-6 w-16 bg-muted rounded-full"></div>
          </div>
        </div>
      ))}
    </div>
  );
};

export const SkeletonTable = ({ rows = 5, columns = 4 }) => {
  return (
    <div className="animate-pulse">
      <div className="bg-card border border-border rounded-lg overflow-hidden">
        {/* Header */}
        <div className="bg-muted p-4 border-b border-border">
          <div className="flex gap-4">
            {Array.from({ length: columns }).map((_, i) => (
              <div key={i} className="h-4 bg-muted-foreground/20 rounded flex-1"></div>
            ))}
          </div>
        </div>
        
        {/* Rows */}
        <div className="divide-y divide-border">
          {Array.from({ length: rows }).map((_, i) => (
            <div key={i} className="p-4">
              <div className="flex gap-4">
                {Array.from({ length: columns }).map((_, j) => (
                  <div key={j} className="h-4 bg-muted rounded flex-1"></div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default SkeletonCard;
